import "./App.css";
import { useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ContactUs from "./View/ContactUs.js";
// import "@fontsource/inter";
// import "@fontsource/inter/400.css";
// import "@fontsource/inter/500.css";
// import "@fontsource/inter/600.css";
// import "@fontsource/inter/700.css";
// import { ToastContainer } from "react-toastify";
import HomePage from "./View/HomePage.js";
import OurStory from "./View/OurStory.js";
import ReserveOccaission from "./View/ReserveOccaission.js";
import ViewProduct from "./View/ViewProduct.js";
import AdminDashboard from "./View/AdminDashboard.js";
import AdminLogin from "./View/AdminLogin.js";
import ProtectedAdminRoute from "./admin/ProtectedAdminRoute.js";
import { SiteSettingsProvider } from "./context/SiteSettingsContext.js";
import Seo from "./Components/Seo.js";

function ScrollToTop() {
  const { pathname, state } = useLocation();
  const previousPathnameRef = useRef(pathname);

  useEffect(() => {
    const pathnameChanged = previousPathnameRef.current !== pathname;
    previousPathnameRef.current = pathname;

    if (!pathnameChanged || state?.scrollToStoryRisePanel) return;

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, state]);

  return null;
}

function App() {
  return (
    <SiteSettingsProvider>
      <div className="App">
        <Seo />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/reserve-occaission" element={<ReserveOccaission />} />
          <Route path="/products/:productId" element={<ViewProduct />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminDashboard />
              </ProtectedAdminRoute>
            }
          />
        </Routes>
      </div>
    </SiteSettingsProvider>
  );
}

export default App;
